import React from 'react'

const STATUS_LABELS = {
  scheduled: 'Programmato',
  confirmed: 'Confermato',
  completed: 'Completato',
  cancelled: 'Annullato',
}

export default function ShiftCard({ shift, compact, onClick, onDelete, canEdit, canDelete }) {
  const userName = shift.user?.fullName || shift.user?.email || 'Utente'
  const sectorName = shift.sector?.name || ''
  const sectorColor = shift.sector?.color || '#dc3545'
  const timeRange = `${shift.startTime?.slice(0, 5) || ''} - ${shift.endTime?.slice(0, 5) || ''}`

  const handleClick = (e) => {
    if (canEdit && onClick) {
      onClick(e)
    }
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    if (canDelete && onDelete) {
      onDelete(e)
    }
  }

  if (compact) {
    return (
      <div
        className={`shift-card shift-card--compact status-${shift.status}`}
        style={{ '--sector-color': sectorColor }}
        onClick={handleClick}
        title={`${userName} - ${sectorName}\n${timeRange}\n${STATUS_LABELS[shift.status] || shift.status}`}
      >
        <span className="shift-card__user">{userName}</span>
        <span className="shift-card__time">{timeRange}</span>
      </div>
    )
  }

  return (
    <div
      className={`shift-card status-${shift.status}`}
      style={{ '--sector-color': sectorColor }}
      onClick={handleClick}
    >
      <div className="shift-card__header">
        <span className="shift-card__user">{userName}</span>
        {canDelete && (
          <button
            type="button"
            className="shift-card__delete"
            onClick={handleDelete}
            title="Elimina turno"
          >
            <i className="fas fa-times" />
          </button>
        )}
      </div>
      <div className="shift-card__details">
        <span className="shift-card__time">
          <i className="fas fa-clock" /> {timeRange}
        </span>
        {sectorName && (
          <span className="shift-card__sector">
            <i className="fas fa-tag" /> {sectorName}
          </span>
        )}
      </div>
      <div className="shift-card__status">
        <span className={`status-badge status-${shift.status}`}>
          {STATUS_LABELS[shift.status] || shift.status}
        </span>
      </div>
      {shift.note && (
        <div className="shift-card__note">
          <i className="fas fa-sticky-note" /> {shift.note}
        </div>
      )}
    </div>
  )
}
